
define('ldsh!modules/editor/templates/edit_element_popup', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-opt-toolbar ed-modal-header js-header">\n</div>\n\n<div class="js-body ed-modal-body">\n</div>\n';

}
return __p
};});

